import { useAuth } from "@/utils/auth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderIcon from "@components/HeaderIcon.jsx";


const AuthenticationPage = ({ children }) => {
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        if (user) {
            navigate("/");
        }
    }, [navigate, user]);

    console.log(user);

    return (
        <div className="authentication">
            <div className="wrapper">
                <HeaderIcon/>
                <form className={`authentication-box`}>{children}</form>
            </div>
        </div>
    );
};

export default AuthenticationPage;